<template>
<div class="container px-0">
    <div class="col-12 main--content-header d-flex justify-content-between">
        <svg-image
            class="mt-2"
            :src="'/svg/' + resource_group + '/chevron-left.svg'"
            v-on:click="back()"
            :auto_hover="true"
            :spaced="true"
        >
            <span class="my-auto">Back</span>
        </svg-image>

        <div
            v-if="!loading"
            class=""
        >
            <a
                :href="smsr_pdf_download_url"
                v-if="form_submission.type === 'site_survey_inspection_report'"
                class="btn btn-primary"
                style="max-height: 40px"
            >
                PDF
            </a>
            <a
                :href="download_url"
                v-if="download_url != null && form_submission.type !== 'site_survey_inspection_report'"
                class="btn btn-primary"
                style="max-height: 40px"
            >
                PDF
            </a>

            <button
                v-if="!form_submission.archived_at"
                class="btn btn-secondary"
                style="max-height: 40px"
                v-on:click="archive()"
            >
                Archive
            </button>
            <button
                v-else
                class="btn btn-primary"
                style="max-height: 40px"
                v-on:click="restore()"
            >
                Restore
            </button>
        </div>
        <loader v-else />
    </div>

    <initial-briefing-submission
        v-if="formInstanceTypeCheck('initial_briefing')"
        :name="form_instance.name"
        :form_submission="form_submission"
        :show_url="people_show_with_back_url"
    />

    <custom-form-submission
        v-else-if="formInstanceTypeCheck(['custom'])"
        :name="form_instance.name"
        :form_submission="form_submission"
        :show_url="people_show_with_back_url"
    />

    <weekly-sheet-submission
        v-else-if="formInstanceTypeCheck('site_operative_register')"
        :form_submission="form_submission"
        :job="job"
    />

    <ncr-defect-submission
        v-else-if="formInstanceTypeCheck('ncr_defect_notice')"
        :form_submission="form_submission"
        :name="form_instance.name"
        :show_url="people_show_with_back_url"
    />

    <toolbox-talks-submission
        v-else-if="formInstanceTypeCheck('toolbox_talks')"
        :form_submission="form_submission"
        :name="form_instance.name"
        :show_url="people_show_with_back_url"
    />

    <training-certificate-submission
        v-else-if="formInstanceTypeCheck('training_certificates')"
        class="form-submission-card"
        :form_submission="form_submission"
        :name="form_instance.name"
    />

    <start-right-minutes-submission
        v-else-if="formInstanceTypeCheck('start_right_minutes')"
        :form_submission="form_submission"
        :name="form_instance.name"
        :show_url="people_show_with_back_url"
    />

    <havs-tools-submission
        v-else-if="formInstanceTypeCheck('havs')"
        class="form-submission-card"
        :form_submission="form_submission"
        :certificate="form_submission.certificate"
        :name="form_instance.name"
    />

    <rams-submission
        v-else-if="formInstanceTypeCheck('rams_ssow')"
        :form_submission="form_submission"
        :name="form_instance.name"
        :show_url="people_show_with_back_url"
    />

    <site-survey-inspection-report-submission
        v-else-if="formInstanceTypeCheck('site_survey_inspection_report')"
        :form_submission="form_submission"
        :smsr_pdf_download_url="smsr_pdf_download_url"
        :name="form_instance.name"
    />

    <ppe-register-submission
        v-else-if="formInstanceTypeCheck('ppe_register')"
        class="form-submission-card"
        :form_submission="form_submission"
        :name="form_instance.name"
    />

    <face-fit-test-submission
        v-else-if="formInstanceTypeCheck('face_fit_test')"
        class="form-submission-card"
        :name="form_instance.name"
        :form_submission="form_submission"
    />

    <ssow-submission
        v-else-if="formInstanceTypeCheck(['coshh', 'risks', 'fixings', 'method_statements'])"
        :form_submission="form_submission"
        :name="form_instance.name"
    />

    <show-signature-modal
        :signature="selected_signature"
        :user="selected_user"
        ref="signature_modal_user"
    />
</div>
</template>

<script>
import InitialBriefingSubmission from "../submissions/InitialBriefingSubmission";
import CustomFormSubmission from "../submissions/CustomFormSubmission";
import WeeklySheetSubmission from "../submissions/WeeklySheetSubmission";
import NcrDefectSubmission from "../submissions/NcrDefectSubmission";
import ToolboxTalksSubmission from "../submissions/ToolboxTalksSubmission";
import TrainingCertificateSubmission from "../submissions/TrainingCertificateSubmission";
import StartRightMinutesSubmission from "../submissions/StartRightMinutesSubmission";
import HavsToolsSubmission from "../submissions/HavsToolsSubmission";
import RAMSSubmission from "../submissions/RAMSSubmission";
import SiteSurveyInspectionReportSubmission from "../submissions/SiteSurveyInspectionReportSubmission";
import SsowSubmission from "../submissions/SsowSubmission";
import ListOfOperativesSignatures from "../forms/ListOfOperativesSignatures";
import PpeRegisterSubmission from "../submissions/PpeRegisterSubmission";
import FaceFitTestSubmission from "../submissions/FaceFitTestSubmission";
import Loader from "../general_components/Loader";
import ShowSignatureModal from "../modals/ShowSignatureModal";

export default {
    name: "SubmissionPage",
    components: {
        CustomFormSubmission,
        FaceFitTestSubmission,
        HavsToolsSubmission,
        InitialBriefingSubmission,
        ListOfOperativesSignatures,
        Loader,
        NcrDefectSubmission,
        PpeRegisterSubmission,
        RAMSSubmission,
        ShowSignatureModal,
        SiteSurveyInspectionReportSubmission,
        SsowSubmission,
        StartRightMinutesSubmission,
        ToolboxTalksSubmission,
        TrainingCertificateSubmission,
        WeeklySheetSubmission,
    },
    props: [
        'form_submission',
        'form_instance',

        'job',

        'smsr_pdf_download_url',
        'download_url',

        'back_url',
        'extra_back_url',
        'people_show_url',
        'archive_url',
        'restore_url'
    ],

    data() {
        return {
            loading: false,
            selected_signature: null,
            selected_user: null
        }
    },

    methods: {
        back() {
            window.location.href = this.back_url;
        },
        openSignature(user, signature) {
            this.selected_user = user;
            this.selected_signature = signature;
            this.$refs.signature_modal_user.open();
        },
        displaySheetDates(date) {
            const monthNames = ["January", "February", "March", "April", "May", "June",
                "July", "August", "September", "October", "November", "December"
            ];
            let _date = new Date(date);
            let _last_date = new Date(_date.setDate(_date.getDate() + 7));
            let _first_date = new Date(date);

            if (_first_date.getMonth() === _last_date.getMonth()) {
                return _first_date.getDate() + ' - ' + _last_date.getDate() + ' ' + monthNames[_last_date.getMonth()];
            }
            else {
                return _first_date.getDate() + ' ' + monthNames[_first_date.getMonth()] + ' - ' + _last_date.getDate() + ' ' + monthNames[_last_date.getMonth()];
            }
        },

        archive() {
            if (!confirm('Are you sure you want to archive submission?'))
                return;

            this.loading = true;
            axios.post(this.archive_url)
                .then(this.back)
                .catch(() => {
                    Vue.$toast.open({
                        message: 'Something went wrong!',
                        type: 'error'
                    });
                });
        },

        restore() {
            this.loading = true;
            axios.post(this.restore_url)
                .then(this.back)
                .catch(() => {
                    Vue.$toast.open({
                        message: 'Something went wrong!',
                        type: 'error'
                    });
                });
        },
        formInstanceTypeCheck(types) {
            if (!Array.isArray(types)) {
                types = [types];
            }

            return types.includes(this.form_instance.type);
        },
    },

    computed: {
        form_ncr_status() {
            let text = '';
            if (this.form_submission.ncr_defect_entry) {
                if (this.form_submission.ncr_defect_entry.type === 'ncr') {
                    text = 'NCR';
                }
                else if (this.form_submission.ncr_defect_entry.type === 'defect') {
                    text = 'Defect';
                }
            }

            if (this.form_submission.resolution) {
                text += ' - Resolved';
            }

            return text;
        },
        people_show_with_back_url() {
            return this.people_show_url + '?back_url=' + this.extra_back_url;
        },
    }
}
</script>
